import React, { useEffect, Suspense, lazy } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AnimatePresence } from 'framer-motion';
import { articleModalSelector, closeArticleModal } from 'store/reducers/global/global-reducer';

import { ResourceModalHandlerBackground } from '../ResourceModalHandler/styled';

const ArticleModal = lazy(() => import('../ArticleModal'));

export default function ArticleModalHandler() {
  const dispatch = useDispatch();
  const articleModal = useSelector(articleModalSelector);

  useEffect(() => {
    document.body.style.overflow = articleModal.show ? 'hidden' : 'auto';
  }, [articleModal.show]);

  useEffect(() => {
    dispatch(closeArticleModal({}));
  }, [location.pathname]);

  return (
    <AnimatePresence>
      {articleModal.show ? (
        <Suspense fallback={<></>}>
          <ArticleModal />
        </Suspense>
      ) : null}
      <AnimatePresence>{articleModal.show && <ResourceModalHandlerBackground />}</AnimatePresence>
    </AnimatePresence>
  );
}
